module.exports = __webpack_public_path__ + "da61d7ef302b8bf871dd0ae796a52f33.svg";